module.exports = __webpack_public_path__ + "media/images/global/icons/door-27100bb6d76b8778561202ec50a3c4a1.svg";